import React, { Fragment, PureComponent } from "react";

import {
  BarChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  PieChart,
  Pie,
  Cell,
} from "recharts";

import Loader from "./../../Loader/Loader.js";
import { Metric, StandardTooltip, selectFormat } from "./../../Utils/Utils.js";
import { XRayTooltip } from "./../../Utils/XrayUtils.js";

import Heading from "./../../Elements/Heading";

import { getXrayTooltipPosition } from "../../../helpers/DOM";

const color = {
  views: "#FC6D52",
  unique_viewers: "#007bff",
  seconds_watched_per_video: "#28a745",
  videos_count: "#e83e8c",
};

const COLORS = ["#FC6D52", "#f4f4f4"];

class TwitterVideoKeyStats extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      widgetsData: props.data.data,
      widgetsInsights: [],
      width: 0,
      height: 0,
      tooltipViews: {
        show: false,
        x: 0,
        y: 0,
      },
      tooltipUniqueViewers: {
        show: false,
        x: 0,
        y: 0,
      },
      tooltipSecondsWatchedPerVideo: {
        show: false,
        x: 0,
        y: 0,
      },
      tooltipVideosCount: {
        show: false,
        x: 0,
        y: 0,
      },
    };

    this.node = React.createRef();
    this.viewsPosition = React.createRef();
    this.uniqueViewersPosition = React.createRef();
    this.secondsWatchedPerVideoPosition = React.createRef();
    this.videosCountPosition = React.createRef();

    this.updatePosition = this.updatePosition.bind(this);
  }

  updatePosition() {
    this.closeTooltipViews();
    this.closeTooltipUniqueViewers();
    this.closeTooltipSecondsWatchedPerVideo();
    this.closeTooltipVideosCount();

    if (!this.chartRef) return;
    const { containerWidth, containerHeight } = this.chartRef.state;
    this.setState({ width: containerWidth, height: containerHeight });
  }

  UNSAFE_componentWillMount() {
    this.updatePosition();
  }

  componentDidMount() {
    this.props.childRef(this);

    window.addEventListener("resize", this.updatePosition);
    window.addEventListener("click", this.handleClickOutside);

    setTimeout(() => {
      this.updatePosition();
    }, 500);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePosition);
    window.removeEventListener("click", this.handleClickOutside);
  }

  closeTooltipViews = (event) => {
    this.setState({
      tooltipViews: { show: false },
    });
  };
  closeTooltipUniqueViewers = (event) => {
    this.setState({
      tooltipUniqueViewers: { show: false },
    });
  };
  closeTooltipSecondsWatchedPerVideo = (event) => {
    this.setState({
      tooltipSecondsWatchedPerVideo: { show: false },
    });
  };
  closeTooltipVideosCount = (event) => {
    this.setState({
      tooltipVideosCount: { show: false },
    });
  };

  handleClickOutside = (e) => {
    if (this.viewsPosition) {
      if (
        this.viewsPosition.current &&
        !this.viewsPosition.current.contains(e.target)
      ) {
        this.closeTooltipViews();
      }
    }
    if (this.uniqueViewersPosition) {
      if (
        this.uniqueViewersPosition.current &&
        !this.uniqueViewersPosition.current.contains(e.target)
      ) {
        this.closeTooltipUniqueViewers();
      }
    }
    if (this.secondsWatchedPerVideoPosition) {
      if (
        this.secondsWatchedPerVideoPosition.current &&
        !this.secondsWatchedPerVideoPosition.current.contains(e.target)
      ) {
        this.closeTooltipSecondsWatchedPerVideo();
      }
    }
    if (this.videosCountPosition) {
      if (
        this.videosCountPosition.current &&
        !this.videosCountPosition.current.contains(e.target)
      ) {
        this.closeTooltipVideosCount();
      }
    }
  };

  getExportData = () => ({
    data: [
      {
        Metric: "Total Views",
        Value: selectFormat(
          "number",
          this.props.data.metrics.views.value,
          "0,0"
        ),
      },
      {
        Metric: "Mins Per Video View",
        Value: selectFormat(
          "minsec",
          this.props.data.metrics.seconds_watched_per_video.value
        ),
      },
      {
        Metric: "Unique Videos Published",
        Value: selectFormat(
          "number",
          this.props.data.metrics.videos_count.value,
          "0,0"
        ),
      },
    ],
    opts: {
      type: "other",
    },
  });

  render() {
    const { loading } = this.props;

    if (loading) {
      return <Loader minHeight={340} col={"col-12 col-md-6"} />;
    }

    const data = this.props.data;
    // const goal = data.per_brand

    data.metrics.views.paid = data.metrics.views.paid || 0;
    data.metrics.views.paid = [
      { value: 100 * data.metrics.views.paid },
      { value: 100 * (1 - data.metrics.views.paid) },
    ];

    return (
      <div className="row key-stats border-between-metrics">
        <div
          className="col-lg-3 col-sm-6 col-12 key-stats--item"
          ref={this.viewsPosition}
        >
          <div className="row row--header">
            <div className="col-7">
              <Heading size={5}>Total Views</Heading>

              <Metric {...data.metrics.views} size={"md"} />

              <div className="row pie-metric align-items-center">
                <div className="col-6">
                  <PieChart height={45} width={45}>
                    <Pie
                      dataKey="value"
                      data={data.metrics.views.paid}
                      outerRadius="100%"
                      innerRadius="75%"
                      startAngle={450}
                      endAngle={90}
                    >
                      {data.metrics.views.paid.map((entry, index) => (
                        <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                      ))}
                    </Pie>
                    <text
                      x="50%"
                      y="50%"
                      textAnchor="middle"
                      dominantBaseline="middle"
                      className="piechart-metric__xsmall"
                    >
                      {selectFormat(
                        "percentage",
                        data.metrics.views.paid[0].value / 100
                      )}
                    </text>
                  </PieChart>
                </div>
                <div className="col-6">
                  <h6 className="widget__metric-label widget__metric-label ml-2 mt-2">
                    Paid
                  </h6>
                </div>
              </div>
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.views} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>

          <ResponsiveContainer height={230} width="100%" className="mt-5">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.views,
              }))}
              onClick={(d) => {
                const extra = [
                  {
                    date: "Total Views",
                    key: selectFormat(
                      "date",
                      d.activePayload[0].payload.date,
                      "MM/DD"
                    ),
                    value: d.activePayload[0].payload.value,
                    color: "#FC6D52",
                  },
                ];
                d.extra = extra;
                this.setState({
                  tooltipViews: { ...d, show: true },
                });
              }}
            >
              {!this.state.tooltipViews.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Total Views
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{ background: color.views }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.views}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color.views}
                    stopOpacity={0.55}
                  />
                  <stop offset="95%" stopColor={color.views} stopOpacity={1} />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.views})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.views} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
          {this.state.tooltipViews.activeCoordinate ? (
            <div
              className="xray-tooltip-container"
              style={{
                top: this.state.tooltipViews.activeCoordinate.y + 80 + "px",
                left:
                  this.state.tooltipViews.activeCoordinate.x + 220 <
                  this.state.width
                    ? this.state.tooltipViews.activeCoordinate.x + 15 + "px"
                    : this.state.tooltipViews.activeCoordinate.x +
                      50 +
                      "px" -
                      getXrayTooltipPosition(
                        this.viewsPosition.current,
                        this.state.tooltipViews.activeCoordinate
                      ) +
                      "px",
                opacity: this.state.tooltipViews.show ? 1.0 : 0.0,
                visibility: this.state.tooltipViews.show ? "visible" : "hidden",
              }}
            >
              <XRayTooltip
                data={this.state.tooltipViews}
                close={this.closeTooltipViews.bind(this)}
              />
            </div>
          ) : null}
        </div>

        {data.metrics.unique_viewers ? (
          <div
            className="col-lg-3 col-sm-6 col-12 key-stats--item"
            ref={this.uniqueViewersPosition}
          >
            <div className="row row--header">
              <div className="col-7">
                <Heading size={5}>Unique Viewers</Heading>

                <Metric {...data.metrics.unique_viewers} size={"md"} />
              </div>
              {/* {
                goal ? (
                  <div className="col-5 mt-1">
                    <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                    <Metric value={goal.unique_viewers} size={"sm"} icon="line" />
                  </div>
                ) : null
              } */}
            </div>

            <ResponsiveContainer height={230} width="100%" className="mt-5">
              <BarChart
                data={data.metricsByDay.map((d) => ({
                  date: d.date,
                  value: d.unique_viewers,
                }))}
                onClick={(d) => {
                  const extra = [
                    {
                      date: "Unique Viewers",
                      key: selectFormat(
                        "date",
                        d.activePayload[0].payload.date,
                        "MM/DD"
                      ),
                      value: d.activePayload[0].payload.value,
                      color: "#007bff",
                    },
                  ];
                  d.extra = extra;
                  this.setState({
                    tooltipUniqueViewers: { ...d, show: true },
                  });
                }}
              >
                {!this.state.tooltipUniqueViewers.show && (
                  <Tooltip
                    cursor={{ fill: "#eee", opacity: 0.5 }}
                    content={
                      <StandardTooltip
                        render={({ data }) => {
                          const payload = data(this.props);
                          if (payload !== null) {
                            return (
                              <div className="standard-tooltip">
                                {Object.keys(payload).map((key) => (
                                  <Fragment key={key}>
                                    <header className="standard-tooltip__header">
                                      <span className="standard-tooltip__key-header">
                                        Unique Viewers
                                      </span>
                                    </header>
                                    <main className="standard-tooltip__main">
                                      <div className="standard-tooltip__item">
                                        <span className="standard-tooltip__key">
                                          <span
                                            className="standard-tooltip__icon"
                                            style={{
                                              background: color.unique_viewers,
                                            }}
                                          ></span>
                                          <span className="standard-tooltip__value-header">
                                            {selectFormat(
                                              "date",
                                              payload[key].payload.date,
                                              "MM/DD"
                                            )}
                                          </span>
                                        </span>
                                        <span className="standard-tooltip__value">
                                          {selectFormat(
                                            "number",
                                            payload[key].value
                                          )}
                                        </span>
                                      </div>
                                    </main>
                                  </Fragment>
                                ))}
                              </div>
                            );
                          }
                        }}
                      />
                    }
                  />
                )}
                <defs>
                  <linearGradient
                    id={`color-${color.unique_viewers}`}
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop
                      offset="5%"
                      stopColor={color.unique_viewers}
                      stopOpacity={0.55}
                    />
                    <stop
                      offset="95%"
                      stopColor={color.unique_viewers}
                      stopOpacity={1}
                    />
                  </linearGradient>
                </defs>
                <Bar
                  dataKey="value"
                  fillOpacity={1}
                  fill={`url(#color-${color.unique_viewers})`}
                  cursor="pointer"
                />
                <XAxis dataKey="date" hide />
                {/* {goal ? <ReferenceLine y={goal.unique_viewers} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
              </BarChart>
            </ResponsiveContainer>
            {this.state.tooltipUniqueViewers.activeCoordinate ? (
              <div
                className="xray-tooltip-container"
                style={{
                  top:
                    this.state.tooltipUniqueViewers.activeCoordinate.y +
                    80 +
                    "px",
                  left:
                    this.state.tooltipUniqueViewers.activeCoordinate.x + 220 <
                    this.state.width
                      ? this.state.tooltipUniqueViewers.activeCoordinate.x +
                        15 +
                        "px"
                      : this.state.tooltipUniqueViewers.activeCoordinate.x +
                        50 +
                        "px" -
                        getXrayTooltipPosition(
                          this.uniqueViewersPosition.current,
                          this.state.tooltipUniqueViewers.activeCoordinate
                        ) +
                        "px",
                  opacity: this.state.tooltipUniqueViewers.show ? 1.0 : 0.0,
                  visibility: this.state.tooltipUniqueViewers.show
                    ? "visible"
                    : "hidden",
                }}
              >
                <XRayTooltip
                  data={this.state.tooltipUniqueViewers}
                  close={this.closeTooltipUniqueViewers.bind(this)}
                />
              </div>
            ) : null}
          </div>
        ) : null}

        <div
          className="col-lg-3 col-sm-6 col-12 key-stats--item"
          ref={this.secondsWatchedPerVideoPosition}
        >
          <div className="row row--header">
            <div className="col-7">
              <Heading size={5}>Mins per Video View</Heading>

              <Metric
                {...data.metrics.seconds_watched_per_video}
                size={"md"}
                type={"minsec"}
              />
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.seconds_watched_per_video} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>

          <ResponsiveContainer height={230} width="100%" className="mt-5">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.seconds_watched_per_video,
              }))}
              onClick={(d) => {
                const extra = [
                  {
                    date: "Mins per Video View",
                    key: selectFormat(
                      "date",
                      d.activePayload[0].payload.date,
                      "MM/DD"
                    ),
                    value: d.activePayload[0].payload.value,
                    keyStatsValue: "keyStatsValue",
                    color: "#28a745",
                  },
                ];
                d.extra = extra;
                this.setState({
                  tooltipSecondsWatchedPerVideo: { ...d, show: true },
                });
              }}
            >
              {!this.state.tooltipSecondsWatchedPerVideo.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Mins per Video View
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{
                                            background:
                                              color.seconds_watched_per_video,
                                          }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "minsec",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.seconds_watched_per_video}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color.seconds_watched_per_video}
                    stopOpacity={0.55}
                  />
                  <stop
                    offset="95%"
                    stopColor={color.seconds_watched_per_video}
                    stopOpacity={1}
                  />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.seconds_watched_per_video})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.seconds_watched_per_video} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
          {this.state.tooltipSecondsWatchedPerVideo.activeCoordinate ? (
            <div
              className="xray-tooltip-container"
              style={{
                top:
                  this.state.tooltipSecondsWatchedPerVideo.activeCoordinate.y +
                  80 +
                  "px",
                left:
                  this.state.tooltipSecondsWatchedPerVideo.activeCoordinate.x +
                    220 <
                  this.state.width
                    ? this.state.tooltipSecondsWatchedPerVideo.activeCoordinate
                        .x +
                      15 +
                      "px"
                    : this.state.tooltipSecondsWatchedPerVideo.activeCoordinate
                        .x +
                      50 +
                      "px" -
                      getXrayTooltipPosition(
                        this.secondsWatchedPerVideoPosition.current,
                        this.state.tooltipSecondsWatchedPerVideo
                          .activeCoordinate
                      ) +
                      "px",
                opacity: this.state.tooltipSecondsWatchedPerVideo.show
                  ? 1.0
                  : 0.0,
                visibility: this.state.tooltipSecondsWatchedPerVideo.show
                  ? "visible"
                  : "hidden",
              }}
            >
              <XRayTooltip
                data={this.state.tooltipSecondsWatchedPerVideo}
                close={this.closeTooltipSecondsWatchedPerVideo.bind(this)}
              />
            </div>
          ) : null}
        </div>

        <div
          className="col-lg-3 col-sm-6 col-12 key-stats--item"
          ref={this.videosCountPosition}
        >
          <div className="row row--header">
            <div className="col-7">
              <Heading size={5}>Unique Videos Published</Heading>

              <Metric
                {...data.metrics.videos_count}
                size={"md"}
                type={"number"}
              />
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.videos_count} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>

          <ResponsiveContainer height={230} width="100%" className="mt-5">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.videos_count,
              }))}
              onClick={(d) => {
                const extra = [
                  {
                    date: "Videos Published",
                    key: selectFormat(
                      "date",
                      d.activePayload[0].payload.date,
                      "MM/DD"
                    ),
                    value: d.activePayload[0].payload.value,
                    color: "#e83e8c",
                  },
                ];
                d.extra = extra;
                this.setState({
                  tooltipVideosCount: { ...d, show: true },
                });
              }}
            >
              {!this.state.tooltipVideosCount.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Videos Published
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{
                                            background: color.videos_count,
                                          }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {payload[key].value}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.videos_count}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color.videos_count}
                    stopOpacity={0.55}
                  />
                  <stop
                    offset="95%"
                    stopColor={color.videos_count}
                    stopOpacity={1}
                  />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.videos_count})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.videos_count} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
          {this.state.tooltipVideosCount.activeCoordinate ? (
            <div
              className="xray-tooltip-container"
              style={{
                top:
                  this.state.tooltipVideosCount.activeCoordinate.y + 80 + "px",
                left:
                  this.state.tooltipVideosCount.activeCoordinate.x + 220 <
                  this.state.width
                    ? this.state.tooltipVideosCount.activeCoordinate.x +
                      15 +
                      "px"
                    : this.state.tooltipVideosCount.activeCoordinate.x +
                      50 +
                      "px" -
                      getXrayTooltipPosition(
                        this.videosCountPosition.current,
                        this.state.tooltipVideosCount.activeCoordinate
                      ) +
                      "px",
                opacity: this.state.tooltipVideosCount.show ? 1.0 : 0.0,
                visibility: this.state.tooltipVideosCount.show
                  ? "visible"
                  : "hidden",
              }}
            >
              <XRayTooltip
                data={this.state.tooltipVideosCount}
                close={this.closeTooltipVideosCount.bind(this)}
              />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default TwitterVideoKeyStats;
